import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";

const Hero = () => {
  const bgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let rafId: number;
    const handleScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        if (bgRef.current) {
          const scrollY = window.scrollY;
          bgRef.current.style.transform = `translateY(${scrollY * 0.35}px)`;
        }
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div
        ref={bgRef}
        className="absolute inset-0 bg-cover bg-center bg-no-repeat will-change-transform scale-110"
        style={{ backgroundImage: "url('/images/hero-bg.webp')" }}
      />
      <div className="absolute inset-0 bg-background/60" />

      <div className="relative z-10 mx-4 w-full max-w-md bg-background/80 backdrop-blur-md border border-border rounded-lg px-6 py-10 md:px-10 md:py-12 flex flex-col items-center gap-4 shadow-2xl">
        <h1 className="sr-only">Luther Club Kaiserslautern – Nachtclub für Events, Party & Live-Musik</h1>
        <img
           src="/logo-white.webp"
           alt="Luther Club Kaiserslautern – Nachtclub & Events"
           width="256"
           height="137"
           fetchPriority="high"
           className="w-48 md:w-64 drop-shadow-2xl"
         />
         <p className="font-[Montserrat] text-xs tracking-[0.3em] uppercase text-primary/80">
           Kaiserslautern
         </p>

        <div className="flex flex-col sm:flex-row gap-4 mt-2 w-full">
          <Link
            to="/menu"
            className="font-[Montserrat] text-sm tracking-[0.15em] uppercase px-8 py-3 bg-primary text-primary-foreground rounded hover:bg-primary/90 transition-colors text-center flex-1"
          >
            Drinks
          </Link>
          <a
            href="#events"
            className="font-[Montserrat] text-sm tracking-[0.15em] uppercase px-8 py-3 border border-primary text-primary rounded hover:bg-primary/10 transition-colors text-center flex-1"
          >
            Events
          </a>
        </div>

      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-primary/50">
          <path d="M12 5v14M5 12l7 7 7-7" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
